export const validColors = ["#e8d863", "#09d6e8", "#ed6afa", "#03de6c"] // "#ff7b54", "#ddeafb", "#999999", "#b6c5cc"]

// Margen (en pb) alrededor del gen dentro del cual un cambio de fase parental
// se considera relevante para la variante diagnosticada. Debe mantenerse en
// sincronía con recombinationFlank en backend/services/embryo.go.
export const RECOMBINATION_FLANK = 1_000_000

// Número mínimo de marcadores consecutivos del mismo color necesarios para
// que un bloque haplotípico cuente como soportado. Debe mantenerse en
// sincronía con minBlockMarkers en backend/services/embryo.go.
export const MIN_BLOCK_MARKERS = 3